export { FullScreen } from './full-screen';
export type { FullScreenProps } from './full-screen';
